export default "assets/images/2a61e310e46b50b5f8ddd5e905ba9db9.png";